import type { Template } from "@/types";

export const LA_06_H1_V5: Template[] = [
    {
        id: "la-05-h1v5-01",
        name: "LA 01 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 107, y: 106, width: 228, height: 320, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 106, width: 227, height: 320, rotation: 0, imageRotation: 0 },
            { id: "3", x: 806, y: 38, width: 413, height: 253, rotation: 0, imageRotation: 0 },
            { id: "4", x: 806, y: 299, width: 133, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 947, y: 299, width: 132, height: 193, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1087, y: 299, width: 132, height: 193, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-02",
        name: "LA 02 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 183, y: 53, width: 310, height: 424, rotation: 0, imageRotation: 0 },
            { id: "2", x: 792, y: 53, width: 143, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 792, y: 269, width: 143, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 53, width: 293, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 269, width: 143, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1094, y: 269, width: 142, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-03",
        name: "LA 03 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 174, y: 280, width: 325, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 174, y: 53, width: 159, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 341, y: 53, width: 158, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 799, y: 53, width: 279, height: 424, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1086, y: 53, width: 139, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1086, y: 269, width: 139, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-04",
        name: "LA 04 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 145, y: 53, width: 386, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 145, y: 278, width: 124, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 277, y: 278, width: 123, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 408, y: 278, width: 123, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 789, y: 101, width: 221, height: 328, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 101, width: 221, height: 328, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v5-05",
        name: "LA 05 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 117, y: 53, width: 442, height: 267, rotation: 0, imageRotation: 0 },
            { id: "2", x: 117, y: 328, width: 105, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 230, y: 328, width: 105, height: 150, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 328, width: 105, height: 150, rotation: 0, imageRotation: 0 },
            { id: "5", x: 456, y: 328, width: 104, height: 150, rotation: 0, imageRotation: 0 },
            { id: "6", x: 862, y: 53, width: 303, height: 425, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-06",
        name: "LA 06 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 82, y: 72, width: 512, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 757, y: 72, width: 124, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 757, y: 271, width: 124, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 889, y: 72, width: 252, height: 390, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1149, y: 72, width: 122, height: 191, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1149, y: 271, width: 122, height: 190, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-07",
        name: "LA 07 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 128, y: 66, width: 128, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 128, y: 270, width: 128, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 66, width: 128, height: 196, rotation: 0, imageRotation: 0 },
            { id: "4", x: 264, y: 270, width: 128, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 400, y: 66, width: 566, height: 400, rotation: 0, imageRotation: 0 },
            { id: "6", x: 974, y: 66, width: 262, height: 400, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-08",
        name: "LA 08 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 82, width: 235, height: 367, rotation: 0, imageRotation: 0 },
            { id: "2", x: 243, y: 82, width: 235, height: 367, rotation: 0, imageRotation: 0 },
            { id: "3", x: 486, y: 82, width: 492, height: 367, rotation: 0, imageRotation: 0 },
            { id: "4", x: 986, y: 82, width: 236, height: 367, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1230, y: 82, width: 122, height: 180, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1230, y: 271, width: 122, height: 179, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-09",
        name: "LA 09 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 97, y: 65, width: 149, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 97, y: 269, width: 149, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 254, y: 65, width: 565, height: 399, rotation: 0, imageRotation: 0 },
            { id: "4", x: 984, y: 65, width: 271, height: 399, rotation: 0, imageRotation: 0 },
            { id: "5", x: 827, y: 65, width: 149, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 827, y: 269, width: 149, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h1v5-10",
        name: "LA 10 - H1V5",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h1_v5_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 203, width: 187, height: 285, rotation: 0, imageRotation: 0 },
            { id: "2", x: 195, y: 203, width: 187, height: 285, rotation: 0, imageRotation: 0 },
            { id: "3", x: 390, y: 203, width: 380, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 778, y: 203, width: 187, height: 285, rotation: 0, imageRotation: 0 },
            { id: "5", x: 973, y: 203, width: 186, height: 285, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1167, y: 203, width: 186, height: 285, rotation: 0, imageRotation: 0 }
        ],
    }
];